export default "__VITE_ASSET__SrkiKJGV__"